// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file contact_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContactCreateSchema, ContactListSchema, ContactSchema, ContactUpdateSchema } from "./contact_pb";
import { file_contact } from "./contact_pb";
import type { ListFilter, ListFilterJson, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file contact_service.proto.
 */
export const file_contact_service: GenFile = /*@__PURE__*/
  fileDesc("ChVjb250YWN0X3NlcnZpY2UucHJvdG8SCXJhY2Nvb25haSJSCg5Db250YWN0UmVxdWVzdBIKCgJpZBgBIAIoBBI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAiACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZCK3AQoSQ29udGFjdExpc3RSZXF1ZXN0EjYKFm93bmVyX29yZ2FuaXphdGlvbl9pZHMYASADKARSFm93bmVyX29yZ2FuaXphdGlvbl9pZHMSMAoTY29udGFpbmVyX2dyb3VwX2lkcxgCIAMoBFITY29udGFpbmVyX2dyb3VwX2lkcxI3CgtsaXN0X2ZpbHRlchgKIAEoCzIVLnJhY2Nvb25haS5MaXN0RmlsdGVyUgtsaXN0X2ZpbHRlcjLkAgoOQ29udGFjdFNlcnZpY2USPwoNQ3JlYXRlQ29udGFjdBIYLnJhY2Nvb25haS5Db250YWN0Q3JlYXRlGhIucmFjY29vbmFpLkNvbnRhY3QiABI9CgpHZXRDb250YWN0EhkucmFjY29vbmFpLkNvbnRhY3RSZXF1ZXN0GhIucmFjY29vbmFpLkNvbnRhY3QiABI/Cg1VcGRhdGVDb250YWN0EhgucmFjY29vbmFpLkNvbnRhY3RVcGRhdGUaEi5yYWNjb29uYWkuQ29udGFjdCIAEkcKDExpc3RDb250YWN0cxIdLnJhY2Nvb25haS5Db250YWN0TGlzdFJlcXVlc3QaFi5yYWNjb29uYWkuQ29udGFjdExpc3QiABJICg1EZWxldGVDb250YWN0EhkucmFjY29vbmFpLkNvbnRhY3RSZXF1ZXN0GhoucmFjY29vbmFpLk1lc3NhZ2VSZXNwb25zZSIAQgZaBC4vcGI", [file_contact, file_general]);

/**
 * @generated from message raccoonai.ContactRequest
 */
export type ContactRequest = Message<"raccoonai.ContactRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.ContactRequest
 */
export type ContactRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.ContactRequest.
 * Use `create(ContactRequestSchema)` to create a new message.
 */
export const ContactRequestSchema: GenMessage<ContactRequest, {jsonType: ContactRequestJson}> = /*@__PURE__*/
  messageDesc(file_contact_service, 0);

/**
 * @generated from message raccoonai.ContactListRequest
 */
export type ContactListRequest = Message<"raccoonai.ContactListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * Matches a contact linked to any of these container groups. With
   * owner_organization_ids also set, organization-level contacts - those linked
   * to no group at all - are returned alongside, which is what a pickup
   * location's card needs: the customer's own contacts plus the site's.
   *
   * @generated from field: repeated uint64 container_group_ids = 2 [json_name = "container_group_ids"];
   */
  containerGroupIds: bigint[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.ContactListRequest
 */
export type ContactListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * Matches a contact linked to any of these container groups. With
   * owner_organization_ids also set, organization-level contacts - those linked
   * to no group at all - are returned alongside, which is what a pickup
   * location's card needs: the customer's own contacts plus the site's.
   *
   * @generated from field: repeated uint64 container_group_ids = 2 [json_name = "container_group_ids"];
   */
  container_group_ids?: string[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.ContactListRequest.
 * Use `create(ContactListRequestSchema)` to create a new message.
 */
export const ContactListRequestSchema: GenMessage<ContactListRequest, {jsonType: ContactListRequestJson}> = /*@__PURE__*/
  messageDesc(file_contact_service, 1);

/**
 * @generated from service raccoonai.ContactService
 */
export const ContactService: GenService<{
  /**
   * @generated from rpc raccoonai.ContactService.CreateContact
   */
  createContact: {
    methodKind: "unary";
    input: typeof ContactCreateSchema;
    output: typeof ContactSchema;
  },
  /**
   * @generated from rpc raccoonai.ContactService.GetContact
   */
  getContact: {
    methodKind: "unary";
    input: typeof ContactRequestSchema;
    output: typeof ContactSchema;
  },
  /**
   * @generated from rpc raccoonai.ContactService.UpdateContact
   */
  updateContact: {
    methodKind: "unary";
    input: typeof ContactUpdateSchema;
    output: typeof ContactSchema;
  },
  /**
   * @generated from rpc raccoonai.ContactService.ListContacts
   */
  listContacts: {
    methodKind: "unary";
    input: typeof ContactListRequestSchema;
    output: typeof ContactListSchema;
  },
  /**
   * @generated from rpc raccoonai.ContactService.DeleteContact
   */
  deleteContact: {
    methodKind: "unary";
    input: typeof ContactRequestSchema;
    output: typeof MessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_contact_service, 0);

